import { useContext } from 'react';
import { BrandInfoContext } from '@core-ui/brand-info-provider';
import useEnabledFeature from '../../useEnabledFeature/useEnabledFeature';

const useCatBreadcrumb = (): boolean => {
  const { abbrBrand } = useContext(BrandInfoContext);
  const feature = `cat-breadcrumb-${abbrBrand}`;

  return useEnabledFeature(feature);
};

export default useCatBreadcrumb;
